import { delayRetrieveRecords, retrieveRecords } from './search';

export const CHANGE_PAGE = 'CHANGE_PAGE';
export function changePage(page, options = {}) {
  return (dispatch) => {
    dispatch({ page, type: CHANGE_PAGE });

    if (options.fetchRecords === false) return;

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(value) {
  return (dispatch) => {
    dispatch({ value, type: CHANGE_SEARCH_TEXT });

    return dispatch(delayRetrieveRecords());
  };
}

export const CHANGE_BROKER_FILTER = 'CHANGE_BROKER_FILTER';
export function changeBrokerFilter(brokerFilter) {
  return (dispatch) => {
    dispatch({ brokerFilter, type: CHANGE_BROKER_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_REFERRAL_SOURCE_FILTER = 'CHANGE_REFERRAL_SOURCE_FILTER';
export function changeReferralSourceFilter(referralSourceFilter) {
  return (dispatch) => {
    dispatch({ referralSourceFilter, type: CHANGE_REFERRAL_SOURCE_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_WAITLIST_FILTER = 'CHANGE_WAITLIST_FILTER';
export function changeWaitlistFilter(waitlistFilter) {
  return (dispatch) => {
    dispatch({ waitlistFilter, type: CHANGE_WAITLIST_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_PROFILE_USER_TYPE_FILTER = 'CHANGE_PROFILE_USER_TYPE_FILTER';
export function changeProfileUserTypeFilter(profileUserTypeFilter) {
  return (dispatch) => {
    dispatch({ profileUserTypeFilter, type: CHANGE_PROFILE_USER_TYPE_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_STATUS_FILTER = 'CHANGE_STATUS_FILTER';
export function changeStatusFilter(statusFilter) {
  return (dispatch) => {
    dispatch({ statusFilter, type: CHANGE_STATUS_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_SORT = 'CHANGE_SORT';
export function changeSort(sort) {
  return (dispatch) => {
    dispatch({ sort, type: CHANGE_SORT });

    return dispatch(retrieveRecords());
  };
}

export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters() {
  return (dispatch) => {
    dispatch({ type: CLEAR_FILTERS });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_PROPERTY_FILTER = 'CHANGE_PROPERTY_FILTER';
export function changePropertyFilter(propertyFilter) {
  return (dispatch) => {
    dispatch({ propertyFilter, type: CHANGE_PROPERTY_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_CA_STATUS_FILTER = 'CHANGE_CA_STATUS_FILTER';
export function changeCaStatusFilter(caStatusFilter) {
  return (dispatch) => {
    dispatch({ caStatusFilter, type: CHANGE_CA_STATUS_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_COMPANY_FILTER = 'CHANGE_COMPANY_FILTER';
export function changeCompanyFilter(companyFilter) {
  return (dispatch) => {
    dispatch({ companyFilter, type: CHANGE_COMPANY_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_MULTIPLE_FILTERS = 'CHANGE_MULTIPLE_FILTERS';
export function changeMultipleFilters(filters) {
  return (dispatch) => {
    dispatch({ filters, type: CHANGE_MULTIPLE_FILTERS });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_START_DATE = 'CHANGE_START_DATE';
export function changeStartDate(updatedDate) {
  return (dispatch) => {
    dispatch({ updatedDate, type: CHANGE_START_DATE });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_END_DATE = 'CHANGE_END_DATE';
export function changeEndDate(updatedDate) {
  return (dispatch) => {
    dispatch({ updatedDate, type: CHANGE_END_DATE });

    return dispatch(retrieveRecords());
  };
}
